export class Identity {
  constructor(public readonly value: string) {}
}
